module.exports = __webpack_public_path__ + "static/img/dev3.379972b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/culture/dev3.jpg
// module id = A3D/
// module chunks = 1